import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import { AuthRole } from '@newfront-insurance/auth-api';

import { useChatOverlayContext } from '../contexts/chat-overlay-context';

export const NOVA_ANALYTICS_FEATURE_FLAG = 'nova-admin-dashboard';

export function useCanViewNovaAnalytics(): boolean {
  const isEnabled = useFeatureFlag(NOVA_ANALYTICS_FEATURE_FLAG, false);
  const { userScopes, isPublicMode } = useChatOverlayContext();
  const isLocalPreviewEnabled =
    // Next.js must inline these variables so this opt-in cannot enable the dashboard in production.
    // eslint-disable-next-line no-process-env
    process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_NOVA_ANALYTICS_PREVIEW === 'true';

  return (isEnabled || isLocalPreviewEnabled) && !isPublicMode && (userScopes?.includes(AuthRole.ENGINEER) ?? false);
}
